var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverFirsticon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 10.8333V22.3437C4.0625 23.2416 4.41918 24.1027 5.05407 24.7376C5.68895 25.3725 6.55005 25.7292 7.44792 25.7292H8.88333C9.49244 25.728 10.0935 25.5898 10.642 25.325C11.1905 25.0601 11.6724 24.6753 12.0521 24.199L14.1375 21.599C14.3913 21.2826 14.7128 21.0274 15.0785 20.8519C15.4441 20.6765 15.8445 20.5854 16.25 20.5854C16.6555 20.5854 17.0559 20.6765 17.4215 20.8519C17.7872 21.0274 18.1087 21.2826 18.3625 21.599L20.4479 24.199C20.8276 24.6753 21.3095 25.0601 21.858 25.325C22.4065 25.5898 23.0076 25.728 23.6167 25.7292H25.0521C25.95 25.7292 26.811 25.3725 27.4459 24.7376C28.0808 24.1027 28.4375 23.2416 28.4375 22.3437V10.8333C28.4375 10.115 28.1522 9.42616 27.6442 8.91825C27.1363 8.41034 26.4475 8.125 25.7292 8.125H6.77083C6.05254 8.125 5.36366 8.41034 4.85575 8.91825C4.34784 9.42616 4.0625 10.115 4.0625 10.8333Z",
    stroke: "#1E3240",
    strokeWidth: 2.70833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47919 16.25C9.47919 16.6092 9.62186 16.9536 9.87581 17.2076C10.1298 17.4615 10.4742 17.6042 10.8334 17.6042C11.1925 17.6042 11.5369 17.4615 11.7909 17.2076C12.0448 16.9536 12.1875 16.6092 12.1875 16.25C12.1875 15.8909 12.0448 15.5465 11.7909 15.2925C11.5369 15.0385 11.1925 14.8959 10.8334 14.8959C10.4742 14.8959 10.1298 15.0385 9.87581 15.2925C9.62186 15.5465 9.47919 15.8909 9.47919 16.25Z",
    stroke: "#1E3240",
    strokeWidth: 2.70833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 16.25C20.3125 16.6092 20.4552 16.9536 20.7091 17.2076C20.9631 17.4615 21.3075 17.6042 21.6667 17.6042C22.0258 17.6042 22.3703 17.4615 22.6242 17.2076C22.8782 16.9536 23.0208 16.6092 23.0208 16.25C23.0208 15.8909 22.8782 15.5465 22.6242 15.2925C22.3703 15.0385 22.0258 14.8959 21.6667 14.8959C21.3075 14.8959 20.9631 15.0385 20.7091 15.2925C20.4552 15.5465 20.3125 15.8909 20.3125 16.25Z",
    stroke: "#1E3240",
    strokeWidth: 2.70833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.5,
    height: 32.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverFirsticon2);
export default __webpack_public_path__ + "static/media/discover-firsticon2.88b6dd0c2d0e6794a6ec15c146780724.svg";
export { ForwardRef as ReactComponent };